import { render, staticRenderFns } from "./RefundPolicy.vue?vue&type=template&id=f79a34bc&scoped=true"
import script from "./refund_policy.js?vue&type=script&lang=js&external"
export * from "./refund_policy.js?vue&type=script&lang=js&external"
import style0 from "./refund_policy.scss?vue&type=style&index=0&id=f79a34bc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79a34bc",
  null
  
)

export default component.exports